(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin-data/selectors/assets/javascripts/create-game.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin-data/selectors/assets/javascripts/create-game.js');
'use strict';

const drawsSelectors = svs.components.marketplaceData.selectors.draws;
const selectors = svs.components.marketplaceRetailAdminData.selectors;
const getGame = state => state.CreateGame;
const getDrawEvents = (state, _ref) => {
  let groupId = _ref.groupId;
  const _getGame = getGame(state),
    drawNumber = _getGame.drawNumber,
    templateId = _getGame.templateId;
  const _ref2 = selectors.gameTemplates.getGameTemplate(state, groupId, templateId) || {},
    productName = _ref2.productName;
  return productName ? drawsSelectors.getDrawEvents(state, {
    drawNumber,
    productName
  }) : undefined;
};
const getDrawEventsByDrawNumber = (state, _ref3) => {
  let drawNumber = _ref3.drawNumber,
    productName = _ref3.productName;
  return productName ? drawsSelectors.getDrawEvents(state, {
    drawNumber,
    productName
  }) : undefined;
};
const getSelectedOutcomes = (state, _ref4) => {
  let groupId = _ref4.groupId,
    productName = _ref4.productName,
    activatedDrawId = _ref4.activatedDrawId;
  const _getGame2 = getGame(state),
    drawNumber = _getGame2.drawNumber;
  const rowId = activatedDrawId ? activatedDrawId : "".concat(groupId, "_").concat(productName, "_").concat(drawNumber);
  return (state.CreateBetProposal[rowId] || {}).data;
};
setGlobal('svs.components.marketplaceRetailAdminData.selectors.createGame', {
  getDrawEvents,
  getGame,
  getSelectedOutcomes,
  getDrawEventsByDrawNumber
});

 })(window);